<div *ngIf="loading">
  <mat-spinner diameter="50"></mat-spinner>
  <div style="margin-bottom:20px;">
  </div>
</div>

<div class="flex justify-center items-center flex-col" *ngIf="!loading">
  <div class = "animation-container">
    @if (data.purchaseResult === 'SUCCESS' && syncStatus.status == "PROCEED") {
      <app-lottie-animation
        [animationPath] = "'assets/lottie/success.json'"
      ></app-lottie-animation>
    }
    @if (data.purchaseResult === 'FAILED' || syncStatus.status == "FAILED" || syncStatus.status == "TIMEOUT") {
      <app-lottie-animation
        [animationPath] = "'assets/lottie/fail.json'"
        [scale] = "2"
      ></app-lottie-animation>
    }
  </div>
  <div class = "text">
    {{ text }}
  </div>
</div>

<div class = "close-button-container">
  <div class = "close-button" mat-dialog-close>
    Bezár
  </div>
</div>